// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import VideoWidgetPanelSideBarTemplate from '@front/templates/VideoWidgetPanelSideBarTemplate.html';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { Resources } from '@shared/localizations/Resources';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import { DataCache } from '@shared/commons/DataCache';
import { PanelSideBarBase } from './PanelSideBarBase';
import { ExternalLinksObserver } from '@shared/commons/UtilsClasses/Observers/ExternalLinksObserver';
import { ExtLinkUtils } from '@shared/commons/UtilsClasses/ExtLinkUtils';
export class VideoWidgetPanelSideBar extends PanelSideBarBase {
    constructor() {
        super();
        this.externalLinksArrayLengthWasSet = null;
        this._extLinksObserver = new ExternalLinksObserver();
        this.onUpdateExternalLinkEvent = (link) => {
            this.updateExternalLinks(DataCache.ExternalLinksCache.getYoutubeExtLinks());
        };
    }
    getType() {
        return ControlsTypes.VideoWidgetPanelSideBar;
    }
    oncomplete() {
        super.oncomplete();
        this.updateExternalLinks(DataCache.ExternalLinksCache.getYoutubeExtLinks());
        this.init();
    }
    init() {
        this._extLinksObserver.subscribeToAdd(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.subscribeToUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.subscribeToRemove(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.run();
    }
    onteardown() {
        this._extLinksObserver.unsubscribeToAdd(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.unsubscribeToUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.unsubscribeToRemove(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.stop();
    }
    updateExternalLinks(links) {
        this.externalLinksArrayLengthWasSet = links.length;
        void this.set({
            visibleCardsNum: this.externalLinksArrayLengthWasSet,
            loaded: links.length !== 0,
            externalLinks: ExtLinkUtils.sortYoutubeLinks(links)
        });
        if (links.length > 0) {
            this.allVideosScrollAdd();
        }
    }
    allVideosScrollAdd() {
        const allVideos = this.find('.videoWidgetPanelSideBar');
        if (!isNullOrUndefined(allVideos)) {
            HtmlScroll.addScroll(allVideos);
        }
    }
    localize() {
        void this.set({
            _noDataText: Resources.getResource('panel.VideoWidget.noDataText'),
            isLoadingText: Resources.getResource('panel.VideoWidget.isLoadingText')
        });
    }
}
PanelSideBarBase.extendWith(VideoWidgetPanelSideBar, {
    template: VideoWidgetPanelSideBarTemplate,
    data: function () {
        return {
            externalLinks: [],
            visibleCardsNum: null, // number of visible external links (videos) in widget
            cards: {},
            loaded: false, // Determines whether the loading of data from the API or MongoDB has fully completed yet
            _noDataText: '', // localized text of noData info
            isLoadingText: '', // localized text of IsLoading info
            cacheReference: null, // reference to DataCache.ExternalLinksCache
            noDataImg: 'videoNoData'
        };
    },
    computed: {
        noDataText: {
            get: function () {
                const visibleCardsNum = this.get('visibleCardsNum');
                const isLoadingText = this.get('isLoadingText');
                const _noDataText = this.get('_noDataText');
                return visibleCardsNum ? isLoadingText : _noDataText;
            },
            set: function (value) { }
        }
    }
});
